/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contributions_Legend_MoreInputs */

const en_contributions_legend_more = /** @type {(inputs: Contributions_Legend_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More`)
};

const ar_contributions_legend_more = /** @type {(inputs: Contributions_Legend_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أكثر`)
};

const bn_contributions_legend_more = /** @type {(inputs: Contributions_Legend_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বেশি`)
};

const de_contributions_legend_more = /** @type {(inputs: Contributions_Legend_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr`)
};

const es_contributions_legend_more = /** @type {(inputs: Contributions_Legend_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más`)
};

const fr_contributions_legend_more = /** @type {(inputs: Contributions_Legend_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const pt_contributions_legend_more = /** @type {(inputs: Contributions_Legend_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais`)
};

const zh_contributions_legend_more = /** @type {(inputs: Contributions_Legend_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`较多`)
};

const tr_contributions_legend_more = /** @type {(inputs: Contributions_Legend_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çok`)
};

const ru_contributions_legend_more = /** @type {(inputs: Contributions_Legend_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Больше`)
};

const pl_contributions_legend_more = /** @type {(inputs: Contributions_Legend_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Więcej`)
};

/**
* | output |
* | --- |
* | "More" |
*
* @param {Contributions_Legend_MoreInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const contributions_legend_more = /** @type {((inputs?: Contributions_Legend_MoreInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contributions_Legend_MoreInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_contributions_legend_more(inputs)
	if (locale === "bn") return bn_contributions_legend_more(inputs)
	if (locale === "de") return de_contributions_legend_more(inputs)
	if (locale === "es") return es_contributions_legend_more(inputs)
	if (locale === "fr") return fr_contributions_legend_more(inputs)
	if (locale === "pt") return pt_contributions_legend_more(inputs)
	if (locale === "zh") return zh_contributions_legend_more(inputs)
	if (locale === "tr") return tr_contributions_legend_more(inputs)
	if (locale === "ru") return ru_contributions_legend_more(inputs)
	if (locale === "pl") return pl_contributions_legend_more(inputs)
	return en_contributions_legend_more(inputs)
});